import { AppService } from "app/services/app.service";

import { AppFilter } from "app/models/app-filter.model";
import { EnqueteVoto } from "app/models/enquete-voto.model";
import { Enquete } from "app/models/enquete.model";
import { Observable } from "rxjs";

export abstract class AbEnquete extends AppService {
  abstract prefixo: string
  abstract getAllFilter(filter: AppFilter): Observable<any>
  abstract getId(id: number): Observable<any>;
  abstract getVisualizarPorId(id: number): Observable<any>;
  abstract getResultadoPorId(id: number): Observable<any>;
  abstract salvar(enquete: Enquete): Observable<any>;
  abstract votar(voto: EnqueteVoto): Observable<any>;
  abstract desativar(id: number);
}